import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import {
  selectDiaryDate,
  selectLoadedVenueId,
  selectSelectedVenue
} from "@/store/slices/diarySlice";
import {
  runCleared,
  selectSpaceOptimiserRun
} from "@/store/slices/spaceOptimiserSlice";

export const SpaceOptimiserRunSync = () => {
  const dispatch = useAppDispatch();
  const run = useAppSelector(selectSpaceOptimiserRun);
  const selectedVenue = useAppSelector(selectSelectedVenue);
  const loadedVenueId = useAppSelector(selectLoadedVenueId);
  const date = useAppSelector(selectDiaryDate);
  const venueId = selectedVenue ?? loadedVenueId ?? undefined;
  const dateKey = date.toISOString().split("T")[0];

  useEffect(() => {
    if (
      run &&
      venueId !== undefined &&
      (venueId !== run.venueId || dateKey !== run.dateKey)
    ) {
      dispatch(runCleared());
    }
  }, [dateKey, dispatch, run, venueId]);

  return null;
};
